var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28625 0.00268021L5.6075 0C3.72148 0 2.50266 1.24429 2.50266 3.17016V4.63181H0.814748C0.668893 4.63181 0.550781 4.74947 0.550781 4.89461V7.01238C0.550781 7.15751 0.669028 7.27504 0.814748 7.27504H2.50266V12.6189C2.50266 12.764 2.62077 12.8815 2.76662 12.8815H4.96886C5.11472 12.8815 5.23283 12.7639 5.23283 12.6189V7.27504H7.20639C7.35224 7.27504 7.47035 7.15751 7.47035 7.01238L7.47116 4.89461C7.47116 4.82492 7.44328 4.75818 7.39386 4.70887C7.34443 4.65955 7.27709 4.63181 7.20706 4.63181H5.23283V3.39275C5.23283 2.79721 5.37545 2.49488 6.1551 2.49488L7.28598 2.49448C7.4317 2.49448 7.54981 2.37681 7.54981 2.23181V0.265341C7.54981 0.120476 7.43183 0.00294824 7.28625 0.00268021Z",
    fill: "#000B33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.e0112ceca70f255a4e5e67c90a238378.svg";
export { ForwardRef as ReactComponent };